import { render, staticRenderFns } from "./MusicSummary.vue?vue&type=template&id=08b29a92"
import script from "./MusicSummary.vue?vue&type=script&lang=js"
export * from "./MusicSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports